
import React from 'react';
import type { VoteRecommendation as VoteRecommendationType } from '../governanceService';

interface VoteRecommendationProps {
    recommendation: VoteRecommendationType;
}

export const VoteRecommendation: React.FC<VoteRecommendationProps> = ({ recommendation }) => {
    const confidenceColor = recommendation.confidence === 'HIGH'
        ? 'text-green-600 dark:text-green-400'
        : 'text-yellow-600 dark:text-yellow-400';

    const confidenceIcon = recommendation.confidence === 'HIGH' ? '🟢' : '🟡';

    return (
        <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
            <div className="flex items-center gap-2 mb-3">
                <span className="text-lg">ℹ️</span>
                <h4 className="font-bold text-blue-900 dark:text-blue-200">
                    Recommendation (Informational)
                </h4>
            </div>

            <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2">
                    <span className="text-blue-700 dark:text-blue-300 font-medium">Recommended:</span>
                    <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900/40 text-blue-900 dark:text-blue-100 rounded font-mono text-xs font-bold">
                        {recommendation.recommended_choice}
                    </span>
                </div>

                <div className="flex items-center gap-2">
                    <span className="text-blue-700 dark:text-blue-300 font-medium">Confidence:</span>
                    <span className={`font-bold ${confidenceColor}`}>
                        {confidenceIcon} {recommendation.confidence}
                    </span>
                </div>
            </div>

            {/* CRITICAL WARNING: Does NOT unlock DECIDED */}
            <div className="mt-3 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-300 dark:border-yellow-700 rounded">
                <div className="flex items-start gap-2">
                    <span className="text-yellow-600 dark:text-yellow-400 text-lg flex-shrink-0">⚠️</span>
                    <div className="text-xs text-yellow-800 dark:text-yellow-200">
                        <p className="font-bold mb-1">Note: This does NOT unlock DECIDED state.</p>
                        <p>A formal Decision is still required to transition to DECIDED. This recommendation is informational only.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
